export default {
  title: '导出数据',
  menu: '导出数据',
  label: {
    startDate: '开始日期',
    endDate: '结束日期',
    today: '今天',
    yesterday: '昨天',
    last7Days: '近 7 天',
    last30Days: '近 30 天',
    includeSubCompany: '是否包含子公司数据',
    name: '名称',
    operator: '操作',
    export: '导出',
    registration: '注册情况导出',
    application: '申请情况导出',
    referral: '推荐情况导出',
    comment: '评论情况导出',
    statusChange: '状态修改情况导出',
    group: '分组情况导出',
    hrLogin: 'HR登录情况导出',
    jobPostingHistory: '职位发布历史导出'
  },
  message: {
    dateRangeRequired: '请选择时间范围',
    dateRangeError: '请选择正确的时间范围'
  }
}
